import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  to?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  icon,
  title,
  subtitle,
  to,
  linkLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
          <i className={`${icon} text-lg`}></i>
        </span>
        <div>
          <h2 className="font-heading text-lg font-black text-foreground-950 md:text-xl">
            {title}
          </h2>
          {subtitle ? (
            <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p>
          ) : null}
        </div>
      </div>
      {to ? (
        <Link
          to={to}
          className="flex shrink-0 items-center gap-1 text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer whitespace-nowrap"
        >
          {linkLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      ) : null}
    </div>
  );
}